import { useSelector, useDispatch } from "react-redux";
import {
    Container,
    Stack,
    Typography,
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import {
    Language,
    Facebook,
    LinkedIn,
    Instagram,
    X,
    Close,
} from "@mui/icons-material";
import { grey, blue } from "@mui/material/colors";

import { selectLinks, setLinks } from "../slice";

const URLInputField = ({ icon, onRemove, textfieldProps }) => {
    return (
        <Stack flexDirection="row" alignItems="center" gap={2}>
            <label htmlFor={textfieldProps.id} style={{ cursor: "pointer" }}>
                {icon}
            </label>
            <TextField
                id={textfieldProps.id}
                color="secondary"
                InputProps={{
                    ...(textfieldProps.value && {
                        endAdornment: (
                            <InputAdornment>
                                <IconButton size="small" onClick={onRemove}>
                                    <Close />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }),
                }}
                {...textfieldProps}
                sx={{ width: "100%" }}
            />
        </Stack>
    );
};

const LinksStep = () => {
    const dispatch = useDispatch();
    const links = useSelector(selectLinks);

    const setLinkValue = (type, value) => {
        dispatch(
            setLinks({
                type,
                value,
            })
        );
    };

    return (
        <Container maxWidth="sm">
            <Stack p={2} gap={2}>
                <Typography color="text.dark">Website</Typography>
                <URLInputField
                    icon={
                        <Language
                            sx={{ color: blue[400], width: 48, height: 48 }}
                        />
                    }
                    textfieldProps={{
                        id: "website",
                        placeholder: "Website URL",
                        value: links.website,
                        onChange: (e) =>
                            setLinkValue("website", e.target.value),
                    }}
                    onRemove={() => setLinkValue("website", "")}
                />
                <Typography color="text.dark">Social Media</Typography>
                <URLInputField
                    icon={
                        <Facebook
                            sx={{ color: "#0E67FF", width: 48, height: 48 }}
                        />
                    }
                    textfieldProps={{
                        id: "facebook",
                        placeholder: "Facebook URL",
                        value: links.facebook,
                        onChange: (e) =>
                            setLinkValue("facebook", e.target.value),
                    }}
                    onRemove={() => setLinkValue("facebook", "")}
                />
                <URLInputField
                    icon={
                        <LinkedIn
                            sx={{ color: "#0F63C5", width: 48, height: 48 }}
                        />
                    }
                    textfieldProps={{
                        id: "linkedin",
                        placeholder: "Linkedin URL",
                        value: links.linkedin,
                        onChange: (e) =>
                            setLinkValue("linkedin", e.target.value),
                    }}
                    onRemove={() => setLinkValue("linkedin", "")}
                />
                <URLInputField
                    icon={
                        <Instagram
                            sx={{ color: "#D84664", width: 48, height: 48 }}
                        />
                    }
                    textfieldProps={{
                        id: "instagram",
                        placeholder: "Instagram URL",
                        value: links.instagram,
                        onChange: (e) =>
                            setLinkValue("instagram", e.target.value),
                    }}
                    onRemove={() => setLinkValue("instagram", "")}
                />
                <URLInputField
                    icon={
                        <X sx={{ color: grey[600], width: 48, height: 48 }} />
                    }
                    textfieldProps={{
                        id: "x",
                        placeholder: "X URL",
                        value: links.x,
                        onChange: (e) => setLinkValue("x", e.target.value),
                    }}
                    onRemove={() => setLinkValue("x", "")}
                />
            </Stack>
        </Container>
    );
};

export default LinksStep;
